
(function(){
  var WRAP='[class*="mz-main-img-wrap"]';
  var lb,imgEl,countEl,list=[],idx=0,dx=0,dy=0,px=0,py=0;

  function best(im){
    var ss=im.getAttribute('srcset');
    if(ss){var u='',bw=-1;ss.split(',').forEach(function(p){
      var t=p.trim().split(/\s+/),w=parseInt(t[1]||'0',10);
      if(t[0]&&w>=bw){bw=w;u=t[0]}});
      if(u)return u;}
    var s=(im.dataset&&im.dataset.src)||im.currentSrc||im.src||'';
    return /[?&]width=/.test(s)?s.replace(/([?&]width=)\d+/,'$11946'):s;
  }
  function build(){
    lb=document.createElement('div');lb.id='alm-lb';lb.tabIndex=-1;lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
    lb.innerHTML='<div class="alm-lb__count"></div>'+
      '<button type="button" class="alm-lb__btn alm-lb__close" aria-label="Fermer"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>'+
      '<button type="button" class="alm-lb__btn alm-lb__nav alm-lb__prev" aria-label="Image precedente"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>'+
      '<button type="button" class="alm-lb__btn alm-lb__nav alm-lb__next" aria-label="Image suivante"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>'+
      '<div class="alm-lb__stage"><img alt=""></div>';
    document.body.appendChild(lb);
    imgEl=lb.querySelector('.alm-lb__stage img');
    countEl=lb.querySelector('.alm-lb__count');
    lb.querySelector('.alm-lb__close').addEventListener('click',close);
    lb.querySelector('.alm-lb__prev').addEventListener('click',function(e){e.stopPropagation();go(-1)});
    lb.querySelector('.alm-lb__next').addEventListener('click',function(e){e.stopPropagation();go(1)});
    lb.addEventListener('click',function(e){
      if(e.target===lb||e.target.classList.contains('alm-lb__stage'))close();
    });
    imgEl.addEventListener('load',function(){imgEl.classList.add('is-ready')});
    var x0=null;
    lb.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    lb.addEventListener('touchend',function(e){
      if(x0===null)return;var d=e.changedTouches[0].clientX-x0;
      if(Math.abs(d)>45)go(d<0?1:-1);x0=null;
    },{passive:true});
  }
  function show(){
    imgEl.classList.remove('is-ready');
    imgEl.src=list[idx];
    countEl.textContent=(idx+1)+' / '+list.length;
    if(list.length>1){var n=new Image();n.src=list[(idx+1)%list.length];}
  }
  function go(d){if(!list.length)return;idx=(idx+d+list.length)%list.length;show()}
  function open(imgs,i){
    if(!lb)build();
    list=imgs.map(best);idx=i<0?0:i;
    lb.classList.add('is-open');document.body.classList.add('alm-lb-open');show();
    try{lb.focus({preventScroll:true})}catch(e){}
  }
  function close(){
    if(!lb)return;
    lb.classList.remove('is-open');document.body.classList.remove('alm-lb-open');
    imgEl.classList.remove('is-ready');imgEl.removeAttribute('src');
  }

  document.addEventListener('pointerdown',function(e){px=e.clientX;py=e.clientY},true);
  document.addEventListener('click',function(e){
    if(lb&&lb.contains(e.target))return;
    var im=e.target&&e.target.closest?e.target.closest(WRAP+' img'):null;
    if(!im)return;
    dx=Math.abs(e.clientX-px);dy=Math.abs(e.clientY-py);
    if(dx>8||dy>8)return;               /* c'etait un glissement, pas un clic */
    var wrap=im.closest(WRAP);if(!wrap)return;
    var imgs=[].slice.call(wrap.querySelectorAll('img'));
    if(!imgs.length)return;
    e.preventDefault();e.stopPropagation();
    open(imgs,imgs.indexOf(im));
  },true);
  document.addEventListener('keydown',function(e){
    if(!lb||!lb.classList.contains('is-open'))return;
    if(e.key==='Escape'){e.preventDefault();close()}
    else if(e.key==='ArrowLeft'){e.preventDefault();go(-1)}
    else if(e.key==='ArrowRight'){e.preventDefault();go(1)}
  });
})();
